import { ChangeDetectorRef, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { MenuModel } from './model/menu.model';
import { MenuService } from './menu.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, SortDirection } from '@angular/material/sort';
import { EmployeeCategoryModel } from '../../employees/employee-category/employee-category/model/employee-category.model';
import { forkJoin } from 'rxjs';
import { PermissionService } from 'src/app/auth/permission.service';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: false
})
export class MenuComponent {

  menuList: MenuModel[] = [];
  showSearch: boolean = false;
  isLoading = true;
  filter: FilterListItemModel[] = [];
  displayedColumns = ['code', 'name', 'description', 'action'];
  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: MenuModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<MenuModel>(true, []);
  dataSource = new MatTableDataSource(this.menuList);
  IsDownloading: boolean = false;
  context: any = [];
  isFilterReady = false;
  permission: any;

  constructor(private breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private menuService: MenuService,
    public permissionService: PermissionService,
    private changeDetector: ChangeDetectorRef,
    private router: Router, private stateManagerService: StateManagerService,) {

    this.permission = permissionService.getPagePermission("menu");
    this.menuList = [];
    // this.context = [{ id: 1, name: 'Discount' },{ id: 2, name: 'Refund' }];
  }
  /**
    * initilaize the device model
    */
  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });

    // ✅ Initialize filters early so searchFilter child is available in ngAfterViewInit
    this.generateFilterList();
    this.isFilterReady = true;
  }

  generateFilterList() {
    this.filter = [
      {
        title: "Code",
        column: "code",
      },
      {
        title: "Name",
        column: "name",
      },
      {
        title: "Description",
        column: "description",
      },
    ];
  }

  /** 
  * Set the datasource
  */
  setDataSource(menuList: MenuModel[]) {
    this.dataSource = new MatTableDataSource(menuList);
    this.dataSource.sort = this.sort;
  }
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {
    // ✅ Use a slightly longer timeout to ensure searchFilter is ready in the DOM
    setTimeout(() => {
      this.loadPreviousState();
    }, 200);
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {
    // ✅ Use hardcoded string as key to avoid issues with minification
    const stateKey = 'MenuComponent';
    var previousState = this.stateManagerService.getState(stateKey);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      // ✅ Fix Mapping mismatch: API uses 'simpleSearch', SearchFilter component implementation expects 'simpleSearch' in setFilter but emits 'freeSearch'
      const filterToSet: any = {
        simpleSearch: previousState.state.search.filters.simpleSearch,
        freeSearch: previousState.state.search.filters.simpleSearch,
        advSearch: previousState.state.search.filters.advSearch,
        custSearch: previousState.state.search.filters.custSearch
      };
      this.searchColumFilter = filterToSet;

      if (this.searchFilter) {
        this.searchFilter.setSearchFilter(this.searchColumFilter, true);
        this.changeDetector.detectChanges();
      } else {
        this.loadData();
      }

    } else {
      this.setSortColumn('name', 'asc');
      this.loadData();
    }

  }

  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });
    this.sort.sort({
      id: column,
      start: direction,
      disableClear: false,
    });

    // this.sort.active=column;
    // this.sort.direction=direction;


  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.menuList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.menuList);
  }

  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  /**
     * Builds the request data to be send to API
     * @returns Request Data
     */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: [
            ...(searchParam.advSearch || []),
            ...this.getDefaultSearchParams(searchParam.advSearch),
          ],
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    return requestData;
  }

  getDefaultSearchParams(searchFilter: any): ColumnFilter[] {
    var defFilter: any = [];
    if (
      searchFilter == undefined ||
      !searchFilter.some((sf: any) => sf.column == "is_system")
    ) {
      defFilter.push({
        column: "is_system",
        operator: "=",
        value: "0",
      });
    }
    return defFilter;
  }

  /**
    * Set the column filter and reaload the daaa
    * @param columFilter 
    */

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();

  }

  /**
    * On delete menu item selected
    * Confirm the action and call the api to update
    */
  onDelete(menuInfo: MenuModel): void {
    const menuId = menuInfo.id;
    const message = `Are you sure, you want to delete ` + (menuInfo.name + "?");
    const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.menuService.delete(menuInfo).subscribe({
          next: (response) => {
            if (response.status == 'SUCCESS') {
              // handle success
              let snckBarData: SnackBarData = {
                type: 'success',
                title: 'Saved',
                message: 'The record for ' + menuInfo.name + " has been deleted succesfully."
              }
              this.snackBarService.openSnackBar(snckBarData);
              this.loadData();
            } else {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          },
          error: (error) => {
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    });
  }

  /**
   * loads the data based on the conditions
   */
  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    let response = this.menuService.getMenuList(requestData).subscribe(response => {
      if (response.status === 'SUCCESS') {
        this.menuList = response.data.menus;
        this.setDataSource(this.menuList);

        // console.log(this.context )
        this.pagingData.length = response.data.total_count;

        if (this.pagingData.length === 0) {
          const snackBarData: SnackBarData = {
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          };
          this.snackBarService.openSnackBar(snackBarData);
          this.selectedItem = undefined;
        } else {
          // ✅ Use hardcoded string as key
          this.stateManagerService.setState('MenuComponent', requestData);
          // this.onRowSelected(this.expenseList[0]);
        }

      } else {
        const snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);
      }

      this.isLoading = false;
    });
  }

  getContextName(value: number): string {
    const context = this.context.find((r: any) => r.value === value);
    return context ? context.name : '';
  }

  /**
  * On menuInfo selected
  * @param menuInfo 
  */
  onRowSelected(menuInfo: MenuModel): void {
    this.selectedItem = menuInfo;
    this.showSummaryPanel = true;
  }

  /**
    *  Set the sort param and relead the data
    * @param $event sort data
    * {"active": "email","direction": "asc"}
    *   
    */
  sortData($event: any): void {

    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: sd.active, order: sd.direction });
    this.loadData();
  }
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }

  /**
 * On edit the item
 * Show the edit dialog
 */
  onEdit(menuInfo: MenuModel): void {

    this.router.navigate(['product/menu-edit', menuInfo.id]);
  }


  /**
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();

  }

  /**
   * On Add clicked
   * Show the dialog to enter new menu
   */
  addClicked(): void {

    this.router.navigate(['product/menu-edit', 0]);

  }

  exportClicked() {
    if (this.pagingData.length === 0) {
      let snackBarData: SnackBarData = {
        message: 'No data found to export. Please remove or change the filter if any.',
        title: 'No Data!!!',
        type: 'warn'
      };
      this.snackBarService.openSnackBar(snackBarData);
      return;
    }
    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.IsDownloading = true;
    this.menuService['downloadExcel'](requestData)
      .subscribe({
        next: (blob: Blob | MediaSource) => {
          // Download logic
          this.IsDownloading = false;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'menu_list.csv'; // Adjust filename if needed
          link.click();
          window.URL.revokeObjectURL(url);
          this.isLoading = false;


        },
        error: (_error: any) => {
          // Handle errors
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.isLoading = false;
          // Display user-friendly error message to the user
        }
      }
      );
  }


}
